import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import OrderDetailsDialog from './OrderDetailsDialog';
import Button from 'screens/components/basic/Button';
import GenericTable from 'screens/components/advanced/GenericTable';
import { getPatientOrders, getOrderDetail } from 'actions/EntityActions';
import Pagination from 'screens/components/basic/Pagination';
import { ProductOrderStatus, ApprovalStatus } from 'constants/enums';
import DialogHeader from 'screens/components/basic/DialogHeader';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class POSOrderHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activePage: 1,
            itemsPerPage: 10,
            orderBy: 'DESC',
            sortBy: 'Id',
            orderDetailsDisplay: false,
            orderDetailsId: 0
        };

        this.showOrderDetails = this.showOrderDetails.bind(this);
        this.sort = this.sort.bind(this);
    }

    sort(sortBy) {
        this.setState(prevState => {
            return {
                ...prevState,
                orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
                sortBy: sortBy
            }
        }, this.getPatientOrders);
    }

    getPatientOrders() {
        const model = {
            branchId: 0,
            orderNumber: null,
            orderDate: null,
            orderEndDate: null,
            orderStartDate: null,
            patientFirstName: "",
            status: 'None',
            total: null,
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
            employeeId: null,
            patientId: this.props.patientId,
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage
        }
        this.props.getPatientOrders(model);
    }

    showOrderDetails(id) {
        this.props.getOrderDetail(id);
        this.showOrderDetailState(id);
    }

    showOrderDetailState = (id) => {
        this.setState({ orderDetailsDisplay: true, orderDetailsId: id });
    }

    hideOrderDetails = () => {
        this.setState({ orderDetailsDisplay: false });
    }

    pageChange = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, () => this.getPatientOrders());
    }

    getOrders = () => {
        return (this.props.patientOrders?.list || []).map(order => {
            return {
                Id: (<a className='link' onClick={() => this.showOrderDetails(order.orderNumber)}> {order.orderNumber} </a>),
                CreatedDate: order.orderDate,
                PatientFirstName: order.recipient !== " " ? order.recipient : 'Anonymous',
                EmployeeFirstName: order.employee !== " " ? order.employee : '',
                total: `$${order.total.toFixed(2)}`
            };
        });
    }

    closeHistory = () => {
        this.pageChange(1);
        this.props.onCancel();
    }

    render() {
        const { t } = this.props;
        const actions = [
            <Button
                key={1}
                type="CancelButton"
                className="btn-space"
                label={t('pos.orderHistory.cancel')}
                secondary={true}
                onTouchTap={() => this.closeHistory()}
            />
        ];

        const actionsDetails = [
            <Button
                key={1}
                type="CancelButton"
                className="btn-space"
                label={t('pos.orderHistory.cancel')}
                secondary={true}
                onTouchTap={() => this.hideOrderDetails()}
            />
        ];

        const order = this.props.orderDetail;
        const products = (this.props.orderDetail?.products || []).map(product => {
            let discountAmount = 0;
            if (product.discountAmount && product.discountType) {
                if (product.discountType == "Percentage") {
                    discountAmount = `${product.discountAmount}%`
                } else {
                    discountAmount = product.discountAmount;
                }
            }
            return {
                productName: product.name,
                productPrice: `$ ${(product.pricePerUnit ? product.pricePerUnit : Number(0)).toFixed(2)}`,
                productQuantity: product.quantity,
                productDiscount: `${(product.discountAmount ? discountAmount : Number(0))}`,
                productTotalPrice: `$${(product.newPrice ? product.newPrice : Number(0)).toFixed(2)}`,
                productStatus: ProductOrderStatus[product.status]
            };
        });
        const approvals = ((this.props.orderDetail?.approvals || []).map(approval => {
            return {
                employeeName: `${approval.employeeFirstName} ${approval.employeeLastName}`,
                date: approval.createdDateString,
                approvalType: ApprovalStatus[approval.approvalType]
            };
        }));

        return (
            <div>
                <DialogInput
                    title={<DialogHeaderWithClose text={t('pos.orderHistory.orderHistory')} handleClose={() => this.props.onCancel()} />}
                    open={this.props.isOpen}
                    actions={actions}
                    autoScrollBodyContent
                >
                    <GenericTable
                        className="table_center tableHeaderwhiteColorFont"
                        multiSelectable={false}
                        enableSelectAll={false}
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        displayRowCheckbox={false}
                        selectable={false}
                        columns={
                            [
                                { key: "Id", label: t("constants.orderNumberSep"), sortable: true },
                                { key: "CreatedDate", label: t("constants.orderDate"), sortable: true },
                                { key: "PatientFirstName", label: t("constants.recipient"), visibleMode: "d-none-xs", sortable: true },
                                { key: "EmployeeFirstName", label: t("pos.page.employee"), visibleMode: "d-none-xs", sortable: true },
                                { key: "total", label: t("common.total"), sortable: true }
                              ]
                        }
                        rows={this.getOrders()}
                        orderBy={this.state.orderBy}
                        sortBy={this.state.sortBy}
                        sort={this.sort}
                        stripedRows={true}
                    />
                    <div className="row">
                        <div className="col-lg-12">
                            <Pagination
                                length={this.props.patientOrders?.total || 0}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={(e) => this.pageChange(e)} />
                        </div>
                    </div>
                </DialogInput>
                <OrderDetailsDialog
                    open={this.state.orderDetailsDisplay}
                    title={`${t('common.orderNum')}: ${order.id}`}
                    handleClose={() => this.hideOrderDetails()}
                    actions={actionsDetails}>
                    {/*<h3 className="nowrap ml-2"><b>Order Number: {order.id}</b></h3>*/}
                    {/*<div className="col-xs-8 col-sm-8 col-md-12 col-lg-12 col-xl-12">*/}
                    <div className="row d-flex mt-3 justify-content-sm-between" style={{ paddingTop: '50px' }}>
                        <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 text-left">
                            <h5 className="nowrap"><b>{t('common.patientNumber')}</b></h5>
                            <h5 className="nowrap"><b>{t('common.firstName')}</b></h5>
                            <h5 className="nowrap"><b>{t('common.lastName')}</b></h5>
                            <h5 className="nowrap"><b>{t('common.employeeName')}</b></h5>
                        </div>
                        <div className="col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 ">
                            <h5>{order.patientId}</h5>
                            <h5>{order.patientFirstName ? order.patientFirstName : 'Anonymous'}</h5>
                            <h5>{order.patientLastName ? order.patientLastName : 'Anonymous'}</h5>
                            <h5>{order ? `${order.employeeFirstName} ${order.employeeLastName}` : ''}</h5>
                        </div>
                        <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1 text-left">
                            <h5><b>{t('common.status')}</b></h5>
                            <h5><b>{t('common.dateText')}</b></h5>
                            {order.onlineOrderCode ? (
                                <h5><b>{t('common.onlineOrderCode')}</b></h5>) : ''}
                            <h5></h5>
                        </div>
                        <div className="col-xs-8 col-sm-8 col-md-4 col-lg-3 col-xl-3 ">
                            <h5>{order.status}</h5>
                            <h5>{order.createdDateString}</h5>
                            {order.onlineOrderCode ? (<h5>{order.onlineOrderCode}</h5>) : ''}
                        </div>
                    </div>

                    <div className="col-xs-8 col-sm-8 col-md-12 col-lg-12 col-xl-12" style={{ marginTop: '20px' }}>
                        <GenericTable
                            className="table_center order_detail_table table_no_padding"
                            multiSelectable={false}
                            enableSelectAll={false}
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            displayRowCheckbox={false}
                            selectable={true}
                            columns={
                                [
                                    { key: "productName", label: t("common.productName") },
                                    { key: "productPrice", label: t("common.price") },
                                    { key: "productQuantity", label: t("pos.accessorySaleDialog.quantity") },
                                    { key: "productDiscount", label: t("pos.springbigOffers.discount") },
                                    { key: "productTotalPrice", label: t("common.totalPrice") },
                                    { key: "productStatus", label: t("common.status") }
                                  ]
                            }
                            rows={products}
                            stripedRows={true}
                        />
                    </div>

                    <div className="row d-flex mt-3 justify-content-sm-between" style={{ paddingTop: '50px' }}>
                        {/*<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">*/}
                        <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-left">
                            <h4 className="nowrap">{t('common.subTotal')}</h4>
                            <h4 className="nowrap">{t('common.discountOnProduct')}</h4>
                            <h4 className="nowrap">{t('common.subTotalIncludingDiscount')}</h4>
                            {

                                order && order.taxesRate && order.taxesRate.length > 0 && order.taxesRate.map(t => (
                                    <h4 className="nowrap" key={t.name}>{t.name}</h4>))

                            }
                            <h4 className="nowrap">{t('common.total')}</h4>
                            <h4 className="nowrap">{t('common.paid')}</h4>
                            <h4 className="nowrap">{t('common.due')}</h4>
                            <h4 className="nowrap">{t('common.change')}</h4>
                            {
                                order && order.payments && order.payments.length > 0 && (<div>
                                    <h4 className="nowrap">{t('pos.printReceipt.paymentReceived')}</h4>
                                    {
                                        order.payments.map((item, index) => {
                                            return (
                                                <h4 className="nowrap" key={index}>{item.name}</h4>
                                            );
                                        })
                                    }
                                </div>)
                            }
                        </div>

                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 ">
                            <h4>$ {(order.subTotal ? order.subTotal : Number(0)).toFixed(2)}</h4>
                            <h4>$ {((order.subTotal - order.subTotalIncludingDiscounts) ? (order.subTotal - order.subTotalIncludingDiscounts) : Number(0)).toFixed(2)}</h4>
                            <h4>$ {(order.subTotalIncludingDiscounts ? order.subTotalIncludingDiscounts : Number(0)).toFixed(2)}</h4>
                            {
                                order && order.taxesRate && order.taxesRate.length > 0 && order.taxesRate.map(t => (
                                    <h4 className="nowrap"
                                        key={t.value}>$ {(t.value ? t.value : Number(0)).toFixed(2)}</h4>))
                            }
                            <h4>$ {(order.total ? order.total : Number(0)).toFixed(2)}</h4>
                            <h4>$ {((order.total - order.balanceDue) ? (order.total - order.balanceDue) : Number(0)).toFixed(2)}</h4>
                            <h4>$ {(order.balanceDue ? order.balanceDue : Number(0)).toFixed(2)}</h4>
                            <h4>$ {(order.change ? order.change : Number(0)).toFixed(2)}</h4>
                            <h4><br /></h4>
                            {
                                order && order.payments ? order.payments.map((item, index) => {
                                    return (
                                        <h4 className="nowrap" key={index}>$ {item.value.toFixed(2)}</h4>
                                    );
                                }) : null
                            }
                        </div>
                        {/*</div>*/}
                    </div>
                    {((order.approvals || []).length > 0) ?
                        <div className="mt-2">
                            <div className="w-80 center-auto">
                                <h4>{t('pos.orderHistory.approvalsForOrder')}</h4>
                                <div className="alert alert-warning">
                                    {order.comment || `No comment was left`}
                                </div>
                                <GenericTable
                                    className="table_center order_detail_table"
                                    multiSelectable={false}
                                    enableSelectAll={false}
                                    displaySelectAll={false}
                                    adjustForCheckbox={false}
                                    displayRowCheckbox={false}
                                    selectable={false}
                                    columns={
                                        [
                                            { key: "employeeName", label: t("common.employeeName") },
                                            { key: "date", label: t("common.dateText") },
                                            { key: "approvalType", label: t("constants.approvalTypeSep") }
                                          ]
                                    }
                                    rows={approvals}
                                    stripedRows={true}
                                />
                            </div>
                        </div>
                        : undefined}
                </OrderDetailsDialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        patientDetail: state.entity.patientDetail,
        patientId: state.entity.idOrderHistoryDialog,
        patientOrders: state.entity.patientOrders,
        branchId: state.common.branchId,
        orderDetail: state.entity.orderDetail
    };
}


function mapDispatchToProps(dispatch) {
    return {
        getPatientOrders: (model) => dispatch(getPatientOrders(model)),
        getOrderDetail: (orderId) => dispatch(getOrderDetail(orderId))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSOrderHistory))